const presupuestoProtheusStatus = {
  A: { label: 'Abierto', color: 'green' },
  B: { label: 'Aprobado', color: 'red' },
  C: { label: 'Anulado', color: 'grey' },
  D: { label: 'No presupuestado', color: 'yellow' },
};

export default presupuestoProtheusStatus;
